
// export default ui;

import { SHOW_SNACKBAR, HIDE_SNACKBAR } from '../constants/actionTypes';

const initialState = {
  snackbar: {
    open: false,
    message: '',
    severity: 'info', // 'info' | 'warning' | 'error' | 'success'
  },
};

export default function ui(state = initialState, action) {
  switch (action.type) {
    case SHOW_SNACKBAR: {
      const payload = action.payload || {};
      return {
        ...state,
        snackbar: {
          open: true,
          message: payload.message || '',
          severity: payload.severity || 'info',
        },
      };
    }

    case HIDE_SNACKBAR:
      return {
        ...state,
        snackbar: {
          ...state.snackbar,
          open: false,
        },
      };

    default:
      return state;
  }
}